import { Directive, ViewContainerRef, inject } from '@angular/core';

@Directive( {
    selector: '[hisDynamicFieldHost]',
    standalone: false
} )
export class FieldDirective {
    viewContainerRef = inject(ViewContainerRef);
}
